module.exports = __webpack_public_path__ + "lp/img/movie_zoomout_dark@2x.60f7ccfd.png";